export class Constants {
  public static readonly quantidadeItensPorPagina = [50, 100, 200, 500, 1000, 2000, 5000];
}
